export default function HeroSection() {
  const handleScroll = (href: string) => {
    const target = document.querySelector(href);
    if (target) target.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="home"
      className="relative w-full min-h-screen flex flex-col items-center justify-center overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/07fc07deeff7fc83be81e4ef76f247f1.jpg"
          alt="Hero background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full text-center px-6 md:px-16 flex flex-col items-center">
        <span className="inline-block text-xs font-semibold tracking-[0.25em] text-white/60 uppercase mb-6 border border-white/20 rounded-full px-5 py-2">
          iOS Platform Experts
        </span>
        <h1 className="text-5xl md:text-7xl font-extrabold text-white leading-tight max-w-4xl mb-6 tracking-tight">
          Modern Apps for
          <br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-300 to-teal-200">
            iOS Security
          </span>
        </h1>
        <p className="text-lg md:text-xl text-white/75 max-w-2xl leading-relaxed mb-10">
          FUSA d.o.o. is a team of experts developing modern applications for the iOS platform,
          designed to enhance user experience and improve the security of mobile devices.
        </p>

        {/* Static stat badges */}
        <div className="flex flex-wrap gap-4 justify-center">
          {[
            { icon: "ri-shield-check-line", label: "Privacy First" },
            { icon: "ri-speed-up-line", label: "Performance Optimized" },
            { icon: "ri-apple-line", label: "iOS Native" },
          ].map((item) => (
            <div
              key={item.label}
              className="flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-5 py-2.5"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className={`${item.icon} text-emerald-300 text-sm`} />
              </div>
              <span className="text-white/90 text-sm font-medium whitespace-nowrap">{item.label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <button
        onClick={() => handleScroll("#about")}
        className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1 cursor-pointer group"
        aria-label="Scroll to about"
      >
        <span className="text-white/40 text-xs tracking-widest uppercase group-hover:text-white/70 transition-colors">Scroll</span>
        <div className="w-5 h-5 flex items-center justify-center">
          <i className="ri-arrow-down-line text-white/40 group-hover:text-white/70 transition-colors" />
        </div>
      </button>
    </section>
  );
}
